<template>
    <div class="text-setting">
        <settings-preset
            v-for="preset in filteredPresets"
            :key="preset.id"
            :preview-text="previewTextNew"
            :preset="preset"
            :type="type"
            @input="onInput"
            @preview-input="onPreviewInput"
        />

        <div v-if="filteredPresets.length < MAX_PRESETS" class="text-setting__button" @click="onAddPreset">
            <font-awesome-icon
                class="text-setting__button-icon"
                size="2x"
                :icon="['fal', 'plus']"
            />

            <span class="text-setting__button-text">
                ADD PRESET
            </span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import uuidv4 from 'uuid/v4';

import SettingsPreset from '@/components/settings/preset/settings-preset';
import { Preset } from '@/data/data-models';
import mapFilters from '@/utils/map-filters';

export default {
    name: 'settings-presets-heading',
    components: { SettingsPreset },

    props: {
        elementType: {
            type: String,
            required: true,
        },

        type: {
            type: String,
            required: true,
        },

        previewText: {
            type: String,
            required: true,
        },

        defaultClasses: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            elementTypeMap: {
                button: ['a-button'],
                heading: ['a-heading', 'a-heading-rich'],
                link: ['a-link'],
                paragraph: ['a-text-single-line', 'a-text-multi-line'],
            },

            presetsNew: [],
            previewTextNew: '',
            MAX_PRESETS: 20,
        };
    },

    computed: {
        ...mapState({
            settings: state => state.settings,
        }),

        filteredPresets() {
            return this.presetsNew.filter(preset => preset.elementTypes.includes(this.elementType));
        },
    },

    watch: {
        settings: {
            handler(settingsNew) {
                if (!settingsNew) return;

                this.presetsNew = settingsNew.presets;
            },
            immediate: true,
        },
    },

    created() {
        this.previewTextNew = this.previewText;
    },

    methods: {
        ...mapFilters(['titleCase']),

        onInput(presetNew) {
            const presetIndex = this.presetsNew.findIndex(preset => preset.id === presetNew.id);

            this.presetsNew[presetIndex] = presetNew;
            this.update();
        },

        onPreviewInput(text) {
            this.previewTextNew = text;
        },

        onAddPreset() {
            const id = uuidv4();
            const presetData = {
                id,
                name: `${ this.titleCase(this.type) } Preset ${ this.filteredPresets.length + 1 }`,
                classes: this.defaultClasses,
                elementTypes: this.elementTypeMap[this.type],
            };

            this.presetsNew.push(new Preset(presetData));
            this.update();
        },

        update() {
            this.$emit('input', 'presets', this.presetsNew);
        },
    },
};
</script>
